<template>
  <div class="EnterAmount">
    <div class="EnterAmount_text">
      <div>输入金额(元）</div>
      <div class="transferredOut">可转出余额￥{{ isPlaceholder }}</div>
    </div>
    <div class="EnterAmount_input_box">
      <div class="EnterAmount_input_fuhao">¥</div>
      <Input
        class="temr"
        :placeholder="isPlaceholder"
        :value="accountBalance"
        :getValue="getValue"
        :setValue="setValue"
        type="number"
      />
      <div
        @click="allTransferred"
        class="allTransferred"
      >
        <span>全部转出</span>
      </div>
    </div>
    <Select
      placeholder="请选择收款账户"
      label="收款账户"
      model="occupation"
      :getSelect="getSelect"
      :columnsTerm="columnsTermMethod"
      :selectValue="selectValue"
    />
    <Button
      :loading="isLoading"
      loadingText="提交中..."
      :text="textButton"
      :disabled="canGoNext"
      :click="submitting"
      class="nextStep"
    />
    <self-popup v-model="ShowPopupContent"></self-popup>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import Select from '@/components/Select.vue';
import { milliFormat } from '@/utils';
import { mapState } from 'vuex';
import Input from './Input.vue';

export default {
  name: 'EnterAmount',
  props: ['textButton', 'getAmountNum'],
  data() {
    return {
      amountValue: '',
      columnsTermMethod: [],
      placeholder: '0.00',
      selectValue: '',
      selectValueID: '',
      accountBalance: '',
      isLoading: false,
      errorMessage: false,
      setValue: '',
      // 弹窗
      ShowPopupContent: '',

    };
  },
  mounted() {
    this.$api.CommonForms.getBalance({
      orderId: this.capitalAccount.orderId,
    }).then((res) => {
      if (res.success) {
        // eslint-disable-next-line camelcase
        const { account_balance } = res.data;
        this.placeholder = milliFormat(account_balance);
        // eslint-disable-next-line camelcase
        this.accountBalance = account_balance;
      } else {
        this.ShowPopupContent = res.returnMessage;
      }
    }).catch(() => {
      this.ShowPopupContent = '网络异常，请稍后再试！';
    });
    this.$api.CommonForms.getAccountList({
      orderId: this.capitalAccount.orderId,
    }).then((res) => {
      if (res.success) {
        // eslint-disable-next-line array-callback-return
        res.data.map((e) => {
          this.columnsTermMethod.push({
            text: `${e.bank_name}(${e.binding_acct_no})`,
            value: e.binding_card_id,
          });
        });
      } else {
        this.ShowPopupContent = res.returnMessage;
      }
    }).catch(() => {
      this.ShowPopupContent = '网络异常，请稍后再试！';
    });
  },
  components: {
    Input,
    Button,
    Select,
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
    isPlaceholder() {
      return this.placeholder;
    },
    canGoNext() {
      let multiCheck = false;
      const regOne = /\S/;
      if (
        !this.amountValue
        || !regOne.test(this.selectValueID)
        || this.isLoading
      ) {
        multiCheck = true;
      }

      return multiCheck;
    },
  },

  methods: {
    getValue(val) {
      this.amountValue = val;
    },
    getSelect(val) {
      this.selectValue = val.occupationText;
      this.selectValueID = val.occupation;
    },
    submitting() {
      this.isLoading = true;
      this.getAmountNum(
        {
          amountValue: this.amountValue,
          selectValueID: this.selectValueID,
        },
        () => {
          this.isLoading = false;
        },
      );
    },
    allTransferred() {
      this.setValue = this.accountBalance;
    },
  },
};
</script>
<style scoped>
.EnterAmount >>> .van-button--default {
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 8px;
  border-radius: 8px;
  font-size: 17px;
  color: #fff;
}

.EnterAmount_input_box {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 8px;
  padding: 0 16px;
  position: relative;
}
.EnterAmount_input_fuhao {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #1c2438;
  margin: 8px 0 16px 10px;
}
.EnterAmount_input_box >>> .van-cell {
  padding: 10px 16px 10px 8px;
}
.EnterAmount_input_box >>> .van-field__body {
  font-size: 20px;
}
.EnterAmount_input_box >>> .van-field__error-message {
  position: absolute;
  left: 0;
  bottom: -7px;
  color: #ff6538;
  font-size: 12px;
  text-align: left;
}

.nextStep {
  margin-top: 20px;
}
.allTransferred {
  font-size: 12px;
  width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  color: #ff6538;
}
.EnterAmount_text {
  height: 32px;
  background: #ffffff;
  line-height: 32px;
  text-align: left;
  padding: 0 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  justify-content: space-between;
}
.EnterAmount_Tiemr {
  background: #fff;
  font-size: 14px;
  color: #1c2438;
  text-align: left;
  padding: 0 16px;
}

.transferredOut {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
}
</style>
